export enum Status {
  ready = 'Ready',
  inProgress = 'inProgress',
  questionnaire = 'Questionnaire',
  results = 'Results',
  completed = 'Completed',
}
